export function formatCurrency(amount: number | null | undefined): string {
  if (amount === null || amount === undefined || isNaN(amount)) return "–";
  return formatNumericInput(amount) + " kr";
}

export function formatNumericInput(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const num = typeof value === "string" ? parseFloat(value.replace(/\s/g, "")) : value;
  if (isNaN(num)) return "";
  return num.toLocaleString("nb-NO").replace(/\u00A0/g, " ");
}

export function parseNumericInput(value: string): number {
  const normalized = value.replace(/\s/g, "");
  const num = parseFloat(normalized);
  return isNaN(num) ? 0 : num;
}

export function formatAuctionEnd(endsAt: string | null): string {
  if (!endsAt) return "Ukjent";
  const end = new Date(endsAt);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const diffDays = Math.round((endDay.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  const timeStr = end.toLocaleTimeString("nb-NO", { hour: "2-digit", minute: "2-digit" });

  if (diffDays === 0) return `I dag kl. ${timeStr}`;
  if (diffDays === 1) return `I morgen kl. ${timeStr}`;
  if (diffDays < 0) return `Avsluttet`;
  return `${end.toLocaleDateString("nb-NO", { day: "numeric", month: "short" })} kl. ${timeStr}`;
}

export function formatMileage(mileage: number | null): string {
  if (mileage === null) return "–";
  return mileage.toLocaleString("nb-NO") + " km";
}

const FUEL_TYPE_LABELS: Record<string, string> = {
  bensin: "Bensin",
  diesel: "Diesel",
  elektrisitet: "Elektrisitet",
  elektrisk: "Elektrisitet",
  electric: "Elektrisitet",
  hybrid: "Bensin Hybrid",
  "bensin hybrid": "Bensin Hybrid",
  "plug-in hybrid": "Ladbar Hybrid",
  "ladbar hybrid": "Ladbar Hybrid",
};

export function normalizeFuelType(fuelType: string | null): string {
  if (!fuelType) return "–";
  return FUEL_TYPE_LABELS[fuelType.toLowerCase()] ?? fuelType;
}

const TRANSMISSION_LABELS: Record<string, string> = {
  automat: "Automat",
  automatic: "Automat",
  manuell: "Manuell",
  manual: "Manuell",
};

export function normalizeTransmission(transmission: string | null): string {
  if (!transmission) return "–";
  return TRANSMISSION_LABELS[transmission.toLowerCase()] ?? transmission;
}

const WHEEL_DRIVE_LABELS: Record<string, string> = {
  fwd: "Foran",
  forhjulsdrift: "Foran",
  rwd: "Bak",
  bakhjulsdrift: "Bak",
  awd: "Alle",
  "4wd": "Alle",
  firehjulsdrift: "Alle",
};

export function normalizeWheelDrive(wheelDrive: string | null): string {
  if (!wheelDrive) return "–";
  return WHEEL_DRIVE_LABELS[wheelDrive.toLowerCase()] ?? wheelDrive;
}
